import axiosInstance from 'src/common/axiosInstance';
import { dedupedRequest, clearRequestCache } from 'src/common/requestCache';

const workspaceWhatsappPhoneNumberService = {

    index(workspaceId, accountId, params = {}) {

        const base = `/workspaces/${workspaceId}/whatsapp-accounts/${accountId}/phone-numbers`;
        const key = `${base}?${new URLSearchParams(params).toString()}`;
        return dedupedRequest(key, () =>
            axiosInstance.get(base, { params }),
        );

    },

    show(workspaceId, accountId, phoneNumberId) {

        return axiosInstance.get(
            `/workspaces/${workspaceId}/whatsapp-accounts/${accountId}/phone-numbers/${phoneNumberId}`
        );

    },

    create(workspaceId, accountId, data) {

        clearRequestCache(`/workspaces/${workspaceId}/whatsapp-accounts/${accountId}/phone-numbers`);
        return axiosInstance.post(
            `/workspaces/${workspaceId}/whatsapp-accounts/${accountId}/phone-numbers`,
            data
        );

    },

    update(workspaceId, accountId, phoneNumberId, data) {

        clearRequestCache(`/workspaces/${workspaceId}/whatsapp-accounts/${accountId}/phone-numbers`);
        return axiosInstance.put(
            `/workspaces/${workspaceId}/whatsapp-accounts/${accountId}/phone-numbers/${phoneNumberId}`,
            data
        );

    },

    destroy(workspaceId, accountId, phoneNumberId) {

        clearRequestCache(`/workspaces/${workspaceId}/whatsapp-accounts/${accountId}/phone-numbers`);
        return axiosInstance.delete(
            `/workspaces/${workspaceId}/whatsapp-accounts/${accountId}/phone-numbers/${phoneNumberId}`
        );

    },

};

export default workspaceWhatsappPhoneNumberService;